import * as fromPages from './action-bars.reducer';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

export const featureKey = 'action-bars';

export interface ContentState {
  actionBars: fromPages.ActionBarsState;
}

export const reducers: ActionReducerMap<ContentState> = {
  actionBars: fromPages.ActionBarReducer,
};

export const getContentState = createFeatureSelector<ContentState>(featureKey);

export const metaReducers: MetaReducer<ContentState>[] = !environment.production ? [] : [];
